import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";

import FormControl from "@mui/material/FormControl";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InfoIcon from "@mui/icons-material/Info";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import SelectQuestionDialog from "./selectQuestionDialog.js";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "185px, -20px, 20px, -180px", //"120px, -20px, 20px, -5px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    min-width: 340px;
    background: #fff;
    color: #000;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: flex;
    padding: 8px 5px 8px 5px;
    flex-direction: column;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
      display: "flex",
      alignItems: "center",
      minHeight: 50,
    },

    [`& .${gridClasses.cell}.colSpan[data-field='question']`]: {
      justifyContent: "center",
      //  paddingRight: 100,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#E3F2FD !important",
    },
  },
  textFieldStyle: {
    minwidth: 80,
    width: 80,
    // paddingTop: 15,
    // paddingBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      height: 40,
      borderRadius: 10,
      fontSize: 16,
      display: "flex",
      justifyContent: "center",
    },
    "& .MuiOutlinedInput-input": {
      textAlign: "center",
      paddingLeft: 20,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  dataGridFooterStyle: {
    height: 56,
    marginBottom: 0,
    backgroundColor: "#99D4FF",
    display: "flex",
    alignItems: "center",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 18,
    fontWeight: 700,
    marginLeft: 10,
  },
}));
const staticData = [
  {
    id: 1,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "Italy", //Applicant answer
        answerList: [], // available answer in form
        scoreList: [], // score for answer in form
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
        ],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5, 5],
        awardedScore: [5, 5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 20,
  },
  {
    id: 2,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "England",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 3,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "USA",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 4,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "USA",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 5,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "South Africa",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
  {
    id: 6,
    applicantsDetailRows: [
      {
        question: { id: 1, value: "Country", checked: true },
        answer: "Germany",
        answerList: [],
        scoreList: [],
        type: "text",
        assignedScore: "N/A",
        awardedScore: "N/A",
      },
      {
        question: {
          id: 2,
          value: "What certifications do you have?",
          checked: true,
        },
        answer: ["Certified Scrum Product Owner", "SAFe PO/PM Certificate"],
        answerList: [
          "Certified Scrum Product Owner",
          "SAFe PO/PM Certificate",
          "CSD",
          "PSM",
        ],
        scoreList: [5, 5, 5, 10],
        type: "checkbox_multiple",
        assignedScore: [5, 5],
        awardedScore: [5, 5],
      },
      {
        question: {
          id: 3,
          value: "Are you currently employed?",
          checked: true,
        },
        answer: ["Full-Time Employed"],
        answerList: ["Full-Time Employed", "Part-Time Employed", "No"],
        scoreList: [5, 5, 0],
        type: "radio_button",
        assignedScore: [5],
        awardedScore: [5],
      },
    ],
    totalScore: 15,
  },
];
function ApplicantsDetail({ applicant, applySelectedQues, initQuesList }) {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [applicantDetail, setApplicantDetail] = useState([]); // all applicant detail rows
  const [detailRows, setDetailRows] = useState([]); // will be updated by selecting the questions
  const [openSelQuesDlg, setOpenSelQuesDlg] = useState(false);
  const [quesList, setQuesList] = useState(initQuesList);

  const [applicantName, setApplicantName] = useState("");

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  useEffect(() => {
    setApplicantName(applicant.applicantName);
  }, [applicant]);

  // useEffect(() => {
  //
  // }, [initQuesList]);

  const [errorMsg, setErrorMsg] = useState({
    noOfSeats: "",
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  useEffect(() => {
    const foundRow = staticData.find((item) => item.id === applicant.id);
    let rows = [];
    //first row with col span
    rows.push({
      index: 0,
      answer: "",
      question: "",
      answerList: [],
      scoreList: [],
      type: "",
      assignedScore: "",
      awardedScore: "",
    });
    for (var i = 0; i < foundRow.applicantsDetailRows.length; i++) {
      let row = [];
      row["index"] = i + 1;
      row["answer"] = foundRow.applicantsDetailRows[i].answer;
      row["question"] = foundRow.applicantsDetailRows[i].question;
      row["type"] = foundRow.applicantsDetailRows[i].type;
      row["answerList"] = foundRow.applicantsDetailRows[i].answerList;
      row["scoreList"] = foundRow.applicantsDetailRows[i].scoreList;
      row["assignedScore"] = foundRow.applicantsDetailRows[i].assignedScore;
      row["awardedScore"] = foundRow.applicantsDetailRows[i].awardedScore;
      rows.push({
        index: row.index,
        answer: row.answer,
        question: row.question,
        answerList: row.answerList,
        scoreList: row.scoreList,
        type: row.type,
        assignedScore: row.assignedScore,
        awardedScore: row.awardedScore,
      });
    }
    if (quesList.length === 0) {
      // set Question list for first time
      let quesList1 = [];
      foundRow.applicantsDetailRows.map((item) => {
        quesList1.push(item.question);
      });
      setQuesList(quesList1);
    }
    setApplicantDetail(rows);
    setDetailRows(rows);
  }, [applicant]);

  useEffect(() => {
    let newList = [];
    if (applicantDetail.length === 0) return;
    applicantDetail.map((row, index) => {
      if (index === 0) newList.push(row); // to show applicant name
      const quesIdx = quesList.findIndex(
        (item) => item.id === row.question.id && item.checked
      );
      if (quesIdx !== -1) newList.push(row);
    });
    setDetailRows(newList);
  }, [quesList, applicantDetail]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  const columns = [
    {
      field: "question",
      headerName: "Question",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) {
          return 4;
        }
        return undefined;
      },
      renderCell: (rows) => {
        let title = (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 10,
              }}
            >
              <Grid item xs={9}>
                <Typography variant="h2">Answer</Typography>
              </Grid>

              <Grid item xs={3} style={{ textAlign: "center" }}>
                <Typography style={{ paddingTop: 3 }} variant="h2">
                  Assigned Score
                </Typography>
              </Grid>
            </Grid>
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type === "checkbox_multiple" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={false}
                        style={{ padding: 5 }}
                      />

                      <Typography variant="h3">{item}</Typography>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type === "radio_button" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          style={{ paddingLeft: 10 }}
                        >
                          <FormControlLabel
                            value={item}
                            control={
                              <Radio checked={false} style={{ padding: 5 }} />
                            }
                            label={
                              <Typography
                                variant="h3"
                                style={{ color: "black" }}
                              >
                                {item}
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
          </Box>
        );
        if (rows.row.index === 0) {
          return (
            <>
              <Typography
                style={{ paddingRight: 5, paddingBottom: 2 }}
                variant="h2"
              >
                Applicant:
              </Typography>
              <Typography variant="h3">{applicantName}</Typography>
            </>
          );
        } else if (
          rows.row.type === "radio_button" ||
          rows.row.type === "checkbox_multiple"
        )
          return (
            <Box
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <StyledTooltip title={title}>
                <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                  <InfoIcon
                    height={24}
                    color="action"
                    style={{ cursor: "pointer" }}
                  />
                </Box>
              </StyledTooltip>
              <Typography variant="h2">{rows.row.question.value}</Typography>
            </Box>
          );
        else
          return (
            <Typography variant="h2">{rows.row.question.value}</Typography>
          );
      },
    },
    {
      field: "applicantAnswer",
      headerName: "Applicant Answer",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.type === "text" || rows.row.type === "textarea") {
          return <Typography variant="h3">{rows.row.answer}</Typography>;
        } else if (rows.row.type === "radio_button") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {rows.row.answer.map((item, i) => (
                      <FormControlLabel
                        value={item}
                        onClick={(e) => e.preventDefault()}
                        style={{ cursor: "default" }}
                        control={
                          <Radio
                            disableRipple
                            onClick={(e) => e.preventDefault()}
                            style={{ cursor: "default" }}
                            checked={true}
                            tabIndex={"-1"}
                          />
                        }
                        label={
                          <Typography variant="h3" style={{ color: "#1d1f21" }}>
                            {item}
                          </Typography>
                        }
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else if (rows.row.type === "checkbox_multiple") {
          return (
            <Grid container>
              <Grid item xs={12}>
                {rows.row.answer.map((item, i) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={true}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                      <Typography variant="h3">{item}</Typography>
                    </Box>
                  </Box>
                ))}
              </Grid>
            </Grid>
          );
        }
      },
    },
    {
      field: "assignedScore",
      headerName: "Assigned Score",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      height: 50,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.assignedScore == "N/A")
          return <div>{rows.row.assignedScore}</div>;
        else {
          return (
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.assignedScore.map((as, index) => (
                <Box
                  pt={0.5}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: 40,
                  }}
                >
                  {as}
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "awardedScore",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 100,
      height: 50,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.awardedScore == "N/A")
          return <div>{rows.row.awardedScore}</div>;
        else {
          return (
            <Box
              pb={0.5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.awardedScore.map((aw, index) => (
                <Box pt={0.5}>
                  <TextField
                    className={classes.textFieldStyle}
                    name="awardedScore"
                    variant="outlined"
                    defaultValue={aw}
                    type="number"
                    InputProps={{
                      inputProps: { min: 0, pattern: "[0-9]*" },
                    }}
                    onKeyPress={(e) => {
                      if (e?.key === "-" || e?.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      updateAssignedScore(e.target.value, rows.row.index, index)
                    }
                  />
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
  ];
  const updateAssignedScore = (value, index, scoreIdx) => {
    const foundAppDetailRow = applicantDetail.find(
      (appDetail) => appDetail.index === index
    );
    foundAppDetailRow.awardedScore[scoreIdx] = parseInt(value);
    const foundDetailRow = detailRows.find((row) => row.index === index);
    foundDetailRow.awardedScore[scoreIdx] = parseInt(value);
  };

  const customFooter = () => {
    let calAssignedScore = 0;
    let calAwardedScore = 0;
    applicantDetail.map((item, index) => {
      if (index === 0) return;
      item.assignedScore !== "N/A" &&
        item.assignedScore.map((ass) => {
          if (parseInt(ass)) calAssignedScore += ass;
        });
      item.awardedScore !== "N/A" &&
        item.awardedScore.map((aw) => {
          if (parseInt(aw)) calAwardedScore += aw;
        });
    });

    return (
      <Grid container className={classes.dataGridFooterStyle}>
        <Grid item xs={8}>
          <Typography className={classes.dataGridFooterTextStyle}>
            Total Score
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            style={{ paddingLeft: 90 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAssignedScore}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            style={{ paddingLeft: 88 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAwardedScore}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  if (loadContent)
    return (
      <>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              onClick={() => setOpenSelQuesDlg(true)}
            >
              Select Questions
            </Button>
          </Grid>
        </Grid>
        <Box style={{ marginTop: 20 }}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={detailRows}
            showCellRightBorder={true}
            //  hideFooter={true}
            autoWidth={true}
            autoHeight={true}
            getRowId={(row) => row.index}
            getRowClassName={(rows) => {
              if (rows.row.index % 2 === 0) return "even";
              else return "odd";
            }}
            getCellClassName={(rows) => {
              if (rows.row.index === 0) return "colSpan";
            }}
            getRowHeight={() => "auto"}
            //experimentalFeatures={{ newEditingApi: true }}
            hideFooterSelectedRowCount
            slots={{
              footer: customFooter,
            }}
          />
        </Box>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              //  style={{width:170, marginRight:45}}
            >
              Save Awarded Score
            </Button>
          </Grid>
        </Grid>
        {openSelQuesDlg && (
          <SelectQuestionDialog
            quesList={quesList}
            applySelections={(selQuesLst) => {
              setOpenSelQuesDlg(false);
              setQuesList(selQuesLst);
              applySelectedQues(selQuesLst);
            }}
            closeDialog={() => setOpenSelQuesDlg(false)}
          />
        )}
      </>
    );
  else return;
}

export default ApplicantsDetail;
